import React from 'react';
import { ContextMessage } from '../types';

type DataContextMenuProps = {
  contextMessage: ContextMessage;
  selectedCount: number;
};

function DataContextMenu({
  contextMessage,
  selectedCount,
}: DataContextMenuProps): JSX.Element {
  const visible = selectedCount > 0;

  const generateContextTitle = (
    contextMessage: ContextMessage,
    selectedCount: number,
  ) => {
    if (selectedCount === 0) {
      return null;
    }

    const dataName =
      selectedCount === 1 ? contextMessage.singular : contextMessage.plural;

    return `${selectedCount} ${dataName} ${contextMessage.message || ''}`;
  };

  return (
    <div
      className={`absolute top-0 left-0 w-full z-10 items-center justify-center flex ${
        visible ? 'visible' : 'invisible'
      }`}
    >
      <div className='inline-flex text-sm text-gray uppercase py-1 px-4 items-center justify-center h-full font-semibold bg-gray-lightest border-b border-l border-r rounded-b-md border-gray-light'>
        {generateContextTitle(contextMessage, selectedCount)}
      </div>
    </div>
  );
}

export default DataContextMenu;
